import React from 'react'
import PropTypes from 'prop-types'
import {Button, Card, CardBody, CardHeader, Input} from 'reactstrap'
import CSVParser from '../helpers/CSVParser'
import ImportItemsAdd from './ImportItemsAdd'

class ImportItemsInput extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            textareaInput: ''
        }
    }

    _handleChangeInput = (e) => {
        const {target: {name, value}} = e
        this.setState({[name]: value}, () => {
            if (name === 'textareaInput') {
                this._handleLoadInput()
            }
        })
    }

    _parseInput = (textareaInput) => {
        if (!textareaInput) return []

        const csvArray = CSVParser(textareaInput, '\t')

        if (!Array.isArray(csvArray) || csvArray.length < 1) return null

        const [keys, ...csvLines] = csvArray
        const _mergeKeysValues = (_keys, values) => {
            return _keys.reduce((obj, key, index) => ({
                ...obj,
                [key]: typeof values[index] === 'string' ? values[index].trim() : null
            }), {})
        }

        return csvLines.map(csvLine => _mergeKeysValues(keys, csvLine))
    }

    _parseJsonFromBase64 = (str) => {
        try {
            const jsonString = atob(str)
            return JSON.parse(jsonString)
        } catch (e) {

        }

        return {}
    }

    _mergeItems = (items) => {
        const results = {}

        for (let item of items) {
            const {
                mockUpFront,
                mockUpBack,
                designFront,
                designBack,
                designSleeves,
                designHood,
                size,
                color,
                quantity,
                type,
                preference,
                externalOrderItemId,
                externalProductTitle,
                ...itemWithoutProduct
            } = item
            
            if (results.hasOwnProperty(item.orderNumber)) {
                for (let i = 0; i < parseInt(quantity); i++) {
                    results[item.orderNumber].products.push({
                        mockUpFront,
                        mockUpBack,
                        designFront,
                        designBack,
                        designSleeves,
                        designHood,
                        size,
                        color: color ? color.toUpperCase() : '',
                        quantity: 1,
                        type: type ? type.toUpperCase() : '',
                        external_order_item_id: externalOrderItemId,
                        external_product_title: externalProductTitle,
                    })
                }
            } else {
                const preferenceObj = this._parseJsonFromBase64(preference)
                const {
                    generate_label_config
                } = {...preferenceObj}

                results[item.orderNumber] = {
                    ...itemWithoutProduct,
                    preference: preferenceObj,
                    generate_label_config,
                    products: [{
                        mockUpFront,
                        mockUpBack,
                        designFront,
                        designBack,
                        designSleeves,
                        designHood,
                        size,
                        color: color ? color.toUpperCase() : '',
                        quantity: 1,
                        type: type ? type.toUpperCase() : '',
                        external_order_item_id: externalOrderItemId,
                        external_product_title: externalProductTitle,
                    }]
                }

                for (let i = 1; i < parseInt(quantity); i++) {
                    results[item.orderNumber].products.push({
                        mockUpFront,
                        mockUpBack,
                        designFront,
                        designBack,
                        designSleeves,
                        designHood,
                        size,
                        color: color ? color.toUpperCase() : '',
                        quantity: 1,
                        type: type ? type.toUpperCase() : '',
                        external_order_item_id: externalOrderItemId,
                        external_product_title: externalProductTitle,
                    })
                }
            }
        }
        return Object.values(results)
    }

    _handleLoadInput = () => {
        const {listSkuActive} = this.props
        const {textareaInput} = this.state
        const items = this._parseInput(textareaInput.trim())

        let newItems = []
        items.map(item => {
            if (item.type && listSkuActive.includes(item.type.toUpperCase())) {
                return newItems.push(item)
            } else {
                return null
            }
        })

        const mergedItems = this._mergeItems(newItems)
        const formattedZipCodeItems = mergedItems.map(item => {
            /*if (item.postalCode.length === 4) {
                return Object.assign({}, item, {postalCode: '0' + item.postalCode})
            }*/

            if (!!item.shipment_name) {
                const parse = item.shipment_name.split('_')

                if (parse[0] === 'ghtk') {
                    const ghtkInfo = {
                        province: item.province || '',
                        district: item.district || '',
                        name: item.name || '',
                        address1: item.address1 || '',
                        phone: item.name || '',
                        ward: item.ward || '',
                        street: item.street || '',
                        hamlet: item.hamlet || '',
                        subtotal: item.subtotal !== undefined ? parseFloat(item.subtotal) : 0,
                        total: item.total !== undefined ? parseFloat(item.total) : 0,
                        email: item.email
                    }

                    return Object.assign({}, item, {ghtk_info: {...ghtkInfo}})
                }
            }

            return Object.assign({}, item)
        })
        this.props.onChange(formattedZipCodeItems)
    }

    _handleAddItem = (item) => {
        const {textareaInput} = this.state
        const csv = this._parseInput(textareaInput.trim())
        if (csv.length === 0) {
            let line1 = ''
            let line2 = ''
            for (let [key, value] of Object.entries(item)) {
                line1 += key + '\t'
                line2 += value + '\t'
            }

            this.setState({
                textareaInput: line1 + '\n' + line2
            }, () => this._handleLoadInput())
        } else {
            let line = ''
            for (let key of Object.keys(csv[0])) {
                line += item[key] || ''
                line += '\t'
            }

            this.setState(prevState => ({textareaInput: prevState.textareaInput + '\n' + line}), () => this._handleLoadInput())
        }
    }

    render() {
        const {textareaInput} = this.state

        return (
            <div className='ImportItemsInput'>
                <ImportItemsAdd onAddItem={this._handleAddItem}/>
                <Card>
                    <CardHeader>
                        <h4 className='d-flex justify-content-between align-items-center w-100 font-weight-bold mb-3'>
                            <div>Input</div>
                        </h4>
                    </CardHeader>
                    <CardBody>
                        <Input className='TextareaInput' type='textarea' name='textareaInput' value={textareaInput}
                               onChange={this._handleChangeInput}/>
                    </CardBody>
                </Card>

                <div className='text-right mt-2'>
                    <Button color='primary' disabled={!textareaInput.length} onClick={this._handleLoadInput}>
                        <i className='icon-spinner11 mr-2'/>
                        Load
                    </Button>
                </div>
            </div>
        )
    }
}

ImportItemsInput.propTypes = {
    onChange: PropTypes.func.isRequired
}

export default ImportItemsInput
